import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElInput } from 'element-plus'
import { Search } from '@element-plus/icons-vue'

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'CandidateSearch',
  props: {
    modelValue: { default: '' },
    placeholder: { default: '请输入关键词' },
    clearable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {





const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElInput), _mergeProps({
    class: ["candidate-search", { 'is-filled': Boolean(_ctx.modelValue) }],
    "model-value": _ctx.modelValue,
    placeholder: _ctx.placeholder,
    clearable: _ctx.clearable,
    disabled: _ctx.disabled,
    "prefix-icon": _unref(Search)
  }, _ctx.$attrs, {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
  }), null, 16, ["class", "model-value", "placeholder", "clearable", "disabled", "prefix-icon"]))
}
}

})